<template>
  <el-select
      :style="{}"
      size="small"
      v-model="userId"
      :loading="isLoading"
      filterable
      clearable
      remote
      :remote-method="getList"
      placeholder="请输入搜索">
    <el-option v-for="item in list" :label="item.userName" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
import { getAdminListAPI } from './api.js';

export default {
  name: 'SelectAdmin',

  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    userId: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false
    }
  },

  created() {
    this.getList('');
  },

  methods: {
    async getList(query) {
      let params = { userName: query };
      this.list = await getAdminListAPI(params);
    }
  }
}
</script>

<style></style>
